export default [
  {
    name: 'Promo Code',
    prop: 'promo_code_id',
    type: 'autocomplete',
    references: 'admin/promo_codes',
    referenceProp: 'code'
  },
  {
    name: 'Discount',
    prop: 'discount_id',
    type: 'autocomplete',
    references: 'admin/discounts',
    referenceProp: 'code'
  }
]
